import * as z from "zod";

export const locationSchema = z.object({
  street1: z.string().nullish(),
  street2: z.string().nullish(),
  city: z.string().nullish(),
  state: z.string().nullish(),
  stateCode: z.string().nullish(),
  postalCode: z.string().nullish(),
  country: z.string().nullish(),
  countryCode: z.string().nullish(),
  ianaTimeZoneName: z.string().nullish(),
  latitude: z.number().nullish(),
  longitude: z.number().nullish(),
});

export const upsertCustomerRequestSchema = z.object({
  email: z.string().email().describe("Email address, used as the upsert key"),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phoneNumber: z
    .string()
    .optional()
    .describe("Phone number in E.164 format (e.g., +12345678900)"),
  location: locationSchema.optional(),
  customFields: z
    .record(z.string(), z.union([z.string(), z.number(), z.boolean()]))
    .optional()
    .describe(
      "Custom field values as key-value pairs. Keys are field names and values can be strings, numbers, or booleans. Date values must be ISO 8601 datetime strings (e.g., '2026-02-24T12:15:00.000Z'). New fields are created automatically if they don't exist yet.",
    ),
});

export interface UpsertCustomerRequest extends z.infer<
  typeof upsertCustomerRequestSchema
> {}

export const upsertCustomerResponseSchema = z.object({
  id: z.string().describe("Redo customer ID"),
  email: z.string(),
  created: z.boolean().describe("True if a new customer was created"),
});

export interface UpsertCustomerResponse extends z.infer<
  typeof upsertCustomerResponseSchema
> {}
